<template>
    <div class="sip-pager" v-if="total">
        <p class="sip-pager__meta">
            Showing {{ from }}–{{ to }} of {{ total }}
        </p>
        <div class="sip-pager__controls">
            <nav class="sip-pager__nav" v-if="lastPage > 1" aria-label="Pagination">
                <button
                    type="button"
                    class="sip-pager__btn"
                    :disabled="currentPage <= 1"
                    aria-label="Previous page"
                    @click="go(currentPage - 1)"
                >‹</button>
                <button
                    v-for="(page, idx) in pageRange"
                    :key="'p-' + idx + '-' + page"
                    type="button"
                    class="sip-pager__btn"
                    :class="{ 'is-active': page === currentPage, 'is-ellipsis': page === '...' }"
                    :disabled="page === '...'"
                    :aria-current="page === currentPage ? 'page' : null"
                    :aria-label="page === '...' ? 'More pages' : 'Page ' + page"
                    @click="go(page)"
                >{{ page }}</button>
                <button
                    type="button"
                    class="sip-pager__btn"
                    :disabled="currentPage >= lastPage"
                    aria-label="Next page"
                    @click="go(currentPage + 1)"
                >›</button>
            </nav>
            <label class="sip-pager__size" v-if="showPageLength">
                <select
                    name="page_length"
                    class="sip-pager__select"
                    :value="pageLength"
                    aria-label="Rows per page"
                    @change="updateValue"
                >
                    <option v-for="option in getConfig('pagination')" :key="option" :value="option">
                        {{ option }} / page
                    </option>
                </select>
            </label>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            pageLength: {
                type: Number,
                default: 10
            },
            records: {
                type: Object
            },
            showPageLength: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            meta() {
                const rec = this.records || {};
                return rec.meta || rec;
            },
            currentPage() {
                return Number(this.meta.current_page) || 1;
            },
            lastPage() {
                return Number(this.meta.last_page) || 1;
            },
            from() {
                return this.meta.from || 0;
            },
            to() {
                return this.meta.to || 0;
            },
            total() {
                return Number(this.meta.total) || 0;
            },
            pageRange() {
                const current = this.currentPage;
                const last = this.lastPage;
                const delta = 2;
                const range = [];
                const pages = [];
                let prev;

                for (let i = 1; i <= last; i++) {
                    if (i === 1 || i === last || (i >= current - delta && i <= current + delta)) {
                        range.push(i);
                    }
                }

                range.forEach(function (i) {
                    if (prev) {
                        if (i - prev === 2) {
                            pages.push(prev + 1);
                        } else if (i - prev !== 1) {
                            pages.push('...');
                        }
                    }
                    pages.push(i);
                    prev = i;
                });

                return pages;
            }
        },
        methods: {
            getConfig(config){
                return helper.getConfig(config);
            },
            updateValue(e){
                this.$emit('update:pageLength', e.target.value);
            },
            go(page){
                if (page === '...' || page < 1 || page > this.lastPage || page === this.currentPage) {
                    return;
                }
                this.$emit('updateRecords', page);
            }
        }
    }
</script>
